/* eslint-disable max-lines */
import gql from 'graphql-tag'

export const createPosts = gql`
  mutation($PK: String!, $title: String!) {
    createPost(PK: $PK, title: $title) {
      PK
      SK
      title
    }
  }
`
export const createContent = gql`
  mutation(
    $addedTargetAreaCategories: Boolean
    $addedNewsCategories: Boolean
    $targetAreaCategoriesArr: [Int]
    $newsCategoriesArr: Int
    $contentPlanner: String
    $matchKey: String
    $storyType: String
    $teamsShortCodes: [String]
    $associationKey: String
    $tournamentKey: String
    $wordPressInfo: wordPressInfoInput
    $peopleValues: [peopleDetailsInput]
    $selectedAutoExpireDate: String
    $selectedAutoDeleteDate: String
    $contentMainCategory: String
    $contentVersion: Int
    $createdAs: String
    $scheduledDate: String
    $scheduledDate_Te: String
    $scheduledDate_En: String
    $scheduledDate_Hi: String
    $scheduledTime: Int
    $scheduledTime_Te: Int
    $scheduledTime_En: Int
    $scheduledTime_Hi: Int
    $sendPushNotification: Boolean
    $bigTextTitle: String
    $bigTextTitle_Te: String
    $bigTextTitle_En: String
    $bigTextTitle_Hi: String
    $pnPriority: String
    $pnTitle: String
    $pnTitle_Te: String
    $pnTitle_En: String
    $pnTitle_Hi: String
    $pnDescription: String
    $pnDescription_Te: String
    $pnDescription_En: String
    $pnDescription_Hi: String
    $sendPNWithImage: Boolean
    $tagsWithGenderTarget: [String]
    $genderSpecific: String
    $allowShare: Boolean
    $allowDownloads: Boolean
    $allowComments: Boolean
    $createInBoxOffice: Boolean
    $contentID: String
    $contentType: String
    $creatorUUID: String
    $originalCreator: String
    $creatorHandle: String
    $creatorName: String
    $type: String
    $contentMetaInfo: contentMetaInfoInput
    $contentLanguages: [String]
    $contentCategory1: String
    $contentCategory2: String
    $contentCategory3: String
    $creatorVideoHashTag1: String
    $creatorVideoHashTag2: String
    $creatorVideoHashTag3: String
    $creatorVideoHashTag4: String
    $creatorVideoHashTag1AndType: String
    $creatorVideoHashTag2AndType: String
    $creatorVideoHashTag3AndType: String
    $creatorVideoHashTag4AndType: String
    $contentStatus: String
    $targetAreas: [String]
    $targetAreaV2: [String]
    $contentVideoKey: String
    $isContentVideo: Boolean
    $stickyPost: Boolean
    $showSticky: String
    $positionFromTop: Int
    $stickyEndDateTime: Int
    $stickyTargetImpressions: Int
    $pushRankUpTo: Int
    $pushRankTo: Int
    $isPushRankActive: Boolean
    $tempPositionFromTop: Int
    $isInAppMessage: Boolean
    $inAppMessageDetails: contentInAppMessage
    $syncToYousaytv: Boolean
  ) {
    createContent(
      input: {
        addedTargetAreaCategories: $addedTargetAreaCategories
        addedNewsCategories: $addedNewsCategories
        targetAreaCategoriesArr: $targetAreaCategoriesArr
        newsCategoriesArr: $newsCategoriesArr
        contentPlanner: $contentPlanner
        syncToYousaytv: $syncToYousaytv
        matchKey: $matchKey
        storyType: $storyType
        teamsShortCodes: $teamsShortCodes
        associationKey: $associationKey
        tournamentKey: $tournamentKey
        wordPressInfo: $wordPressInfo
        peopleValues: $peopleValues
        selectedAutoExpireDate: $selectedAutoExpireDate
        selectedAutoDeleteDate: $selectedAutoDeleteDate
        contentMainCategory: $contentMainCategory
        contentVersion: $contentVersion
        createdAs: $createdAs
        scheduledDate: $scheduledDate
        scheduledDate_Te: $scheduledDate_Te
        scheduledDate_En: $scheduledDate_En
        scheduledDate_Hi: $scheduledDate_Hi
        scheduledTime: $scheduledTime
        scheduledTime_Te: $scheduledTime_Te
        scheduledTime_En: $scheduledTime_En
        scheduledTime_Hi: $scheduledTime_Hi
        sendPushNotification: $sendPushNotification
        bigTextTitle: $bigTextTitle
        bigTextTitle_Te: $bigTextTitle_Te
        bigTextTitle_En: $bigTextTitle_En
        bigTextTitle_Hi: $bigTextTitle_Hi
        pnPriority: $pnPriority
        pnTitle: $pnTitle
        pnTitle_Te: $pnTitle_Te
        pnTitle_En: $pnTitle_En
        pnTitle_Hi: $pnTitle_Hi
        pnDescription: $pnDescription
        pnDescription_Te: $pnDescription_Te
        pnDescription_En: $pnDescription_En
        pnDescription_Hi: $pnDescription_Hi
        sendPNWithImage: $sendPNWithImage
        tagsWithGenderTarget: $tagsWithGenderTarget
        genderSpecific: $genderSpecific
        allowShare: $allowShare
        allowDownloads: $allowDownloads
        allowComments: $allowComments
        createInBoxOffice: $createInBoxOffice
        contentID: $contentID
        contentType: $contentType
        creatorUUID: $creatorUUID
        originalCreator: $originalCreator
        creatorHandle: $creatorHandle
        creatorName: $creatorName
        type: $type
        contentMetaInfo: $contentMetaInfo
        contentLanguages: $contentLanguages
        contentCategory1: $contentCategory1
        contentCategory2: $contentCategory2
        contentCategory3: $contentCategory3
        creatorVideoHashTag1: $creatorVideoHashTag1
        creatorVideoHashTag2: $creatorVideoHashTag2
        creatorVideoHashTag3: $creatorVideoHashTag3
        creatorVideoHashTag4: $creatorVideoHashTag4
        creatorVideoHashTag1AndType: $creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType: $creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType: $creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType: $creatorVideoHashTag4AndType
        contentStatus: $contentStatus
        targetAreas: $targetAreas
        targetAreaV2: $targetAreaV2
        contentVideoKey: $contentVideoKey
        isContentVideo: $isContentVideo
        stickyPost: $stickyPost
        showSticky: $showSticky
        positionFromTop: $positionFromTop
        stickyEndDateTime: $stickyEndDateTime
        stickyTargetImpressions: $stickyTargetImpressions
        pushRankUpTo: $pushRankUpTo
        pushRankTo: $pushRankTo
        isPushRankActive: $isPushRankActive
        tempPositionFromTop: $tempPositionFromTop
        isInAppMessage: $isInAppMessage
        inAppMessageDetails: $inAppMessageDetails
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateContent = gql`
  mutation(
    $contentPlanner: String
    $matchKey: String
    $storyType: String
    $teamsShortCodes: [String]
    $associationKey: String
    $tournamentKey: String
    $wordPressInfo: wordPressInfoInput
    $PK: String
    $SK: String
    $peopleValues: [peopleDetailsInput]
    $selectedAutoExpireDate: String
    $selectedAutoDeleteDate: String
    $contentMainCategory: String
    $scheduledDate: String
    $scheduledTime: Int
    $tagsWithGenderTarget: [String]
    $genderSpecific: String
    $allowShare: Boolean
    $allowComments: Boolean
    $createInBoxOffice: Boolean
    $sendPushNotification: Boolean
    $bigTextTitle: String
    $bigTextTitle_Te: String
    $bigTextTitle_En: String
    $bigTextTitle_Hi: String
    $pnPriority: String
    $pnTitle: String
    $pnTitle_Te: String
    $pnTitle_En: String
    $pnTitle_Hi: String
    $pnDescription: String
    $pnDescription_Te: String
    $pnDescription_En: String
    $pnDescription_Hi: String
    $sendPNWithImage: Boolean
    $contentType: String
    $contentMetaInfo: updateContentMetaInfoInput
    $contentLanguages: [String]
    $contentCategory1: String
    $contentCategory2: String
    $contentCategory3: String
    $creatorVideoHashTag1: String
    $creatorVideoHashTag2: String
    $creatorVideoHashTag3: String
    $creatorVideoHashTag4: String
    $creatorVideoHashTag1AndType: String
    $creatorVideoHashTag2AndType: String
    $creatorVideoHashTag3AndType: String
    $creatorVideoHashTag4AndType: String
    $targetAreas: [String]
    $targetAreaV2: [String]
    $stickyPost: Boolean
    $showSticky: String
    $positionFromTop: Int
    $stickyEndDateTime: Int
    $stickyTargetImpressions: Int
    $pushRankUpTo: Int
    $pushRankTo: Int
    $isPushRankActive: Boolean
    $tempPositionFromTop: Int
    $isInAppMessage: Boolean
    $inAppMessageDetails: contentInAppMessage
    $syncToYousaytv: Boolean
  ) {
    updateContent(
      input: {
        contentPlanner: $contentPlanner
        matchKey: $matchKey
        storyType: $storyType
        teamsShortCodes: $teamsShortCodes
        associationKey: $associationKey
        tournamentKey: $tournamentKey
        wordPressInfo: $wordPressInfo
        PK: $PK
        SK: $SK
        peopleValues: $peopleValues
        selectedAutoExpireDate: $selectedAutoExpireDate
        selectedAutoDeleteDate: $selectedAutoDeleteDate
        contentMainCategory: $contentMainCategory
        scheduledDate: $scheduledDate
        scheduledTime: $scheduledTime
        tagsWithGenderTarget: $tagsWithGenderTarget
        genderSpecific: $genderSpecific
        allowShare: $allowShare
        allowComments: $allowComments
        createInBoxOffice: $createInBoxOffice
        sendPushNotification: $sendPushNotification
        bigTextTitle: $bigTextTitle
        bigTextTitle_Te: $bigTextTitle_Te
        bigTextTitle_En: $bigTextTitle_En
        bigTextTitle_Hi: $bigTextTitle_Hi
        pnPriority: $pnPriority
        pnTitle: $pnTitle
        pnTitle_Te: $pnTitle_Te
        pnTitle_En: $pnTitle_En
        pnTitle_Hi: $pnTitle_Hi
        pnDescription: $pnDescription
        pnDescription_Te: $pnDescription_Te
        pnDescription_En: $pnDescription_En
        pnDescription_Hi: $pnDescription_Hi
        sendPNWithImage: $sendPNWithImage
        contentType: $contentType
        contentMetaInfo: $contentMetaInfo
        contentLanguages: $contentLanguages
        contentCategory1: $contentCategory1
        contentCategory2: $contentCategory2
        contentCategory3: $contentCategory3
        creatorVideoHashTag1: $creatorVideoHashTag1
        creatorVideoHashTag2: $creatorVideoHashTag2
        creatorVideoHashTag3: $creatorVideoHashTag3
        creatorVideoHashTag4: $creatorVideoHashTag4
        creatorVideoHashTag1AndType: $creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType: $creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType: $creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType: $creatorVideoHashTag4AndType
        targetAreas: $targetAreas
        targetAreaV2: $targetAreaV2
        stickyPost: $stickyPost
        showSticky: $showSticky
        positionFromTop: $positionFromTop
        stickyEndDateTime: $stickyEndDateTime
        stickyTargetImpressions: $stickyTargetImpressions
        pushRankUpTo: $pushRankUpTo
        pushRankTo: $pushRankTo
        isPushRankActive: $isPushRankActive
        tempPositionFromTop: $tempPositionFromTop
        isInAppMessage: $isInAppMessage
        inAppMessageDetails: $inAppMessageDetails
        syncToYousaytv: $syncToYousaytv
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const pushContentToSocialMedia = gql`
  mutation($facebook: Boolean, $instagram: Boolean, $url: String!, $message: String) {
    pushContentToSocialMedia(
      input: { facebook: $facebook, instagram: $instagram, url: $url, message: $message }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const createCampaign = gql`
  mutation($shortURL: String!, $longURL: String!) {
    createCampaign(input: { shortURL: $shortURL, longURL: $longURL }) {
      statusCode
      statusMessage
    }
  }
`
export const publishContent2Point0 = gql`
  mutation(
    $PK: String
    $SK: String
    $approveContentInLanguages: [String]
    $appInfoFrontEnd: appInfoFrontEndInput
    $contentPublishedBy: String
  ) {
    publishContent2Point0(
      input: {
        PK: $PK
        SK: $SK
        approveContentInLanguages: $approveContentInLanguages
        appInfoFrontEnd: $appInfoFrontEnd
        contentPublishedBy: $contentPublishedBy
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const deleteContent = gql`
  mutation($contentID: String) {
    deleteContent(input: { contentID: $contentID }) {
      statusCode
      statusMessage
    }
  }
`
export const createPeople = gql`
  mutation(
    $peopleType: String
    $peopleName: String
    $peopleValue: String!
    $peopleCoverImage: String
    $peopleProfileImage: String
    $peopleDescription: String
    $peopleTemplate: String
  ) {
    createPeople(
      input: {
        peopleType: $peopleType
        peopleName: $peopleName
        peopleValue: $peopleValue
        peopleCoverImage: $peopleCoverImage
        peopleProfileImage: $peopleProfileImage
        peopleDescription: $peopleDescription
        peopleTemplate: $peopleTemplate
      }
    ) {
      addedDetails {
        PK
        SK
        createdDateTime
        peopleType
        peopleValue
        peopleName
        peopleCoverImage
        peopleProfileImage
        peopleDescription
        peopleTemplate
      }
      statusDetails {
        statusCode
        statusMessage
      }
    }
  }
`
export const deletePeople = gql`
  mutation($peopleValue: String!) {
    deletePeople(input: { peopleValue: $peopleValue }) {
      statusCode
      statusMessage
    }
  }
`
export const updatePeople = gql`
  mutation(
    $PK: String!
    $SK: String!
    $peopleName: String
    $peopleType: String
    $peopleCoverImage: String
    $peopleProfileImage: String
    $peopleDescription: String
    $peopleTemplate: String
  ) {
    updatePeople(
      input: {
        PK: $PK
        SK: $SK
        peopleName: $peopleName
        peopleType: $peopleType
        peopleCoverImage: $peopleCoverImage
        peopleProfileImage: $peopleProfileImage
        peopleDescription: $peopleDescription
        peopleTemplate: $peopleTemplate
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const archiveContent = gql`
  mutation(
    $contentID: String
    $ModeratorID: String
    $moderatorHandle: String
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    archiveContent(
      input: {
        contentID: $contentID
        ModeratorID: $ModeratorID
        moderatorHandle: $moderatorHandle
        appInfoFrontEnd: $appInfoFrontEnd
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const addCollectionToPeople = gql`
  mutation(
    $peopleValue: String!
    $collectionValue: String!
    $sectionPosition: Int
    $sectionLabel_Te: String
    $sectionLabel_En: String
    $sectionLabel_Hi: String
    $sectionScroll: String
    $sectionColumns: Int
    $sectionConfigType: String
    $displayAfter: Int
  ) {
    addCollectionToPeople(
      input: {
        peopleValue: $peopleValue
        displayAfter: $displayAfter
        collectionValue: $collectionValue
        sectionPosition: $sectionPosition
        sectionLabel_Te: $sectionLabel_Te
        sectionLabel_En: $sectionLabel_En
        sectionLabel_Hi: $sectionLabel_Hi
        sectionColumns: $sectionColumns
        sectionScroll: $sectionScroll
        sectionConfigType: $sectionConfigType
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const addListToPeople = gql`
  mutation(
    $listValue: String!
    $peopleValue: String!
    $sectionPosition: Int
    $sectionLabel_Te: String
    $sectionLabel_En: String
    $sectionLabel_Hi: String
    $sortBy: String
    $sectionScroll: String
    $sectionColumns: Int
    $sectionConfigType: String
    $showAsSubPage: Boolean
    $displayAfter: Int
  ) {
    addListToPeople(
      input: {
        listValue: $listValue
        peopleValue: $peopleValue
        sortBy: $sortBy
        sectionPosition: $sectionPosition
        sectionLabel_Te: $sectionLabel_Te
        sectionLabel_En: $sectionLabel_En
        sectionLabel_Hi: $sectionLabel_Hi
        sectionColumns: $sectionColumns
        sectionScroll: $sectionScroll
        sectionConfigType: $sectionConfigType
        displayAfter: $displayAfter
        showAsSubPage: $showAsSubPage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const addPageSectionToPeople = gql`
  mutation(
    $peopleValue: String
    $pages: [String]
    $sectionPosition: Int
    $sectionLabel_Te: String
    $sectionLabel_En: String
    $sectionLabel_Hi: String
    $sectionScroll: String
    $sectionColumns: Int
    $displayAfter: Int
  ) {
    addPageSectionToPeople(
      input: {
        peopleValue: $peopleValue
        pages: $pages
        displayAfter: $displayAfter
        sectionPosition: $sectionPosition
        sectionLabel_Te: $sectionLabel_Te
        sectionLabel_En: $sectionLabel_En
        sectionLabel_Hi: $sectionLabel_Hi
        sectionColumns: $sectionColumns
        sectionScroll: $sectionScroll
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const addPeopleSectionToPeople = gql`
  mutation(
    $peopleValue: String
    $addedpeople: [String]
    $sectionPosition: Int
    $sectionLabel_Te: String
    $sectionLabel_En: String
    $sectionLabel_Hi: String
    $sectionScroll: String
    $sectionColumns: Int
    $displayAfter: Int
  ) {
    addPeopleSectionToPeople(
      input: {
        peopleValue: $peopleValue
        displayAfter: $displayAfter
        addedpeople: $addedpeople
        sectionPosition: $sectionPosition
        sectionLabel_Te: $sectionLabel_Te
        sectionLabel_En: $sectionLabel_En
        sectionLabel_Hi: $sectionLabel_Hi
        sectionColumns: $sectionColumns
        sectionScroll: $sectionScroll
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateSectionPositions = gql`
  mutation($PK: String, $sectionValues: [sectionValuesInput]) {
    updateSectionPositions(input: { PK: $PK, sectionValues: $sectionValues }) {
      statusCode
      statusMessage
    }
  }
`
export const updateSectionDetails = gql`
  mutation(
    $PK: String
    $SK: String
    $sectionLabel_Te: String
    $sectionLabel_En: String
    $sectionLabel_Hi: String
    $sortBy: String
    $sectionScroll: String
    $sectionColumns: Int
    $sectionConfigType: String
    $displayAfter: Int
    $showAsSubPage: Boolean
  ) {
    updateSectionDetails(
      input: {
        PK: $PK
        SK: $SK
        sortBy: $sortBy
        sectionLabel_Te: $sectionLabel_Te
        sectionLabel_En: $sectionLabel_En
        sectionLabel_Hi: $sectionLabel_Hi
        sectionColumns: $sectionColumns
        sectionScroll: $sectionScroll
        sectionConfigType: $sectionConfigType
        showAsSubPage: $showAsSubPage
        displayAfter: $displayAfter
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateSection = gql`
  mutation(
    $PK: String
    $SK: String
    $pages: [String]
    $people: [String]
    $addedPages: [String]
    $addedpeople: [String]
  ) {
    updateSection(
      input: {
        PK: $PK
        SK: $SK
        pages: $pages
        people: $people
        addedPages: $addedPages
        addedpeople: $addedpeople
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const removeSection = gql`
  mutation($PK: String, $SK: String) {
    removeSection(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const removeListFromPeople = gql`
  mutation($PK: String, $SK: String) {
    removeListFromPeople(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const removeCollectionFromPeople = gql`
  mutation($PK: String, $SK: String) {
    removeCollectionFromPeople(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const addContentToBoxOffice = gql`
  mutation(
    $contentID: String
    $ModeratorID: String
    $moderatorHandle: String
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    addContentToBoxOffice(
      input: {
        contentID: $contentID
        ModeratorID: $ModeratorID
        moderatorHandle: $moderatorHandle
        appInfoFrontEnd: $appInfoFrontEnd
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const createTemplate = gql`
  mutation(
    $templateName: String!
    $templateType: String!
    $sectionsArray: [sectionsArrayInput]
    $sections: [String]!
  ) {
    createTemplate(
      input: {
        templateName: $templateName
        templateType: $templateType
        sectionsArray: $sectionsArray
        sections: $sections
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const addSectionsToPeople = gql`
  mutation($peopleValue: String!, $sections: [SectionsInput]) {
    addSectionsToPeople(input: { peopleValue: $peopleValue, sections: $sections }) {
      statusCode
      statusMessage
    }
  }
`
export const updateContentPoints = gql`
  mutation(
    $contentID: String
    $points: Int
    $ModeratorID: String
    $newsOnTopFor: String
    $moderatorHandle: String
    $rank: Int
    $customNewsTime: Int
    $fromPosition: Int
    $isDraggedStickyPost: Boolean
  ) {
    updateContentPoints(
      input: {
        contentID: $contentID
        points: $points
        ModeratorID: $ModeratorID
        newsOnTopFor: $newsOnTopFor
        moderatorHandle: $moderatorHandle
        rank: $rank
        customNewsTime: $customNewsTime
        fromPosition: $fromPosition
        isDraggedStickyPost: $isDraggedStickyPost
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const replaceContentPoints = gql`
  mutation($contentID: String, $points: Int, $ModeratorID: String) {
    replaceContentPoints(
      input: { contentID: $contentID, points: $points, ModeratorID: $ModeratorID }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const deleteTemplate = gql`
  mutation($templateValue: String!) {
    deleteTemplate(templateValue: $templateValue) {
      statusCode
      statusMessage
    }
  }
`
export const clearUserHistory = gql`
  mutation($type: String, $userID: String) {
    clearUserHistory(type: $type, userID: $userID) {
      statusCode
      statusMessage
    }
  }
`
export const contentAnalytics = gql`
  mutation($input: contentAnalyticsInput) {
    contentAnalytics(input: $input) {
      statusCode
      statusMessage
    }
  }
`
export const videoAnalytics = gql`
  mutation($input: videoAnalyticsInput) {
    videoAnalytics(input: $input) {
      statusCode
      statusMessage
    }
  }
`
export const deleteContentInSingleLanguage = gql`
  mutation($contentID: String!, $language: String!) {
    deleteContentInSingleLanguage(input: { contentID: $contentID, language: $language }) {
      statusCode
      statusMessage
    }
  }
`

export const repostContent = gql`
  mutation(
    $contentID: String
    $oldContentID: String
    $contentMainCategory: String
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    repostContent(
      input: {
        contentID: $contentID
        oldContentID: $oldContentID
        contentMainCategory: $contentMainCategory
        appInfoFrontEnd: $appInfoFrontEnd
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const addToList = gql`
  mutation(
    $type: String
    $listValue: String
    $contentID: String
    $videoID: String
    $hashtag: String
    $channel: String
    $contentCategory: String
    $contentCategoryLevel: Int
    $contentCategoryTree: String
    $comment: String
    $addedToListByUUID: String
    $addedToListByHandle: String
    $dataTypes: [String]
    $configTargetAreas: [String]
    $excludeContentCategories: [String]
    $appInfoFrontEnd: appInfoFrontEndInput
    $coverStoryType: String
  ) {
    addToList(
      input: {
        type: $type
        listValue: $listValue
        contentID: $contentID
        coverStoryType: $coverStoryType
        videoID: $videoID
        hashtag: $hashtag
        channel: $channel
        configTargetAreas: $configTargetAreas
        contentCategoryTree: $contentCategoryTree
        dataTypes: $dataTypes
        contentCategory: $contentCategory
        contentCategoryLevel: $contentCategoryLevel
        comment: $comment
        addedToListByUUID: $addedToListByUUID
        addedToListByHandle: $addedToListByHandle
        excludeContentCategories: $excludeContentCategories
        appInfoFrontEnd: $appInfoFrontEnd
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const removeFromList = gql`
  mutation(
    $type: String
    $listValue: String
    $contentID: String
    $videoID: String
    $hashtag: String
    $channel: String
    $contentCategory: String
    $contentCategoryLevel: Int
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    removeFromList(
      input: {
        type: $type
        listValue: $listValue
        contentID: $contentID
        videoID: $videoID
        hashtag: $hashtag
        channel: $channel
        contentCategoryLevel: $contentCategoryLevel
        contentCategory: $contentCategory
        appInfoFrontEnd: $appInfoFrontEnd
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const createTwitterPost = gql`
  mutation($title: String!, $contentID: String, $urls: [String]) {
    createTwitterPost(input: { title: $title, contentID: $contentID, urls: $urls }) {
      statusCode
      statusMessage
    }
  }
`

export const updateNewsArticleStatus = gql`
  mutation(
    $PK: String
    $SK: String
    $newsarticleStatus: String
    $newsarticleStatusUpdatedBy: String
    $newsarticleSortTime: Int
  ) {
    updateNewsArticleStatus(
      input: {
        PK: $PK
        SK: $SK
        newsarticleStatus: $newsarticleStatus
        newsarticleStatusUpdatedBy: $newsarticleStatusUpdatedBy
        newsarticleSortTime: $newsarticleSortTime
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const initiateCrawling = gql`
  mutation($sync: Boolean) {
    initiateCrawling(input: { sync: $sync }) {
      statusCode
      statusMessage
    }
  }
`
export const updateNewsArticles = gql`
  mutation($articles: [updateNewsArticleStatusInput]) {
    updateNewsArticles(input: { articles: $articles }) {
      statusCode
      statusMessage
    }
  }
`
export const createUserHashTag = gql`
  mutation($UUID: String, $userHashTags: [String], $wordPressTagIDs: [Int], $tagsLanguage: String) {
    createUserHashTag(
      input: {
        UUID: $UUID
        userHashTags: $userHashTags
        wordPressTagIDs: $wordPressTagIDs
        tagsLanguage: $tagsLanguage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const createCricketTeam = gql`
  mutation($teamName: String, $teamShortName: String, $teamLogo: String, $teamImage: String) {
    createCricketTeam(
      input: {
        teamName: $teamName
        teamShortName: $teamShortName
        teamLogo: $teamLogo
        teamImage: $teamImage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const updateCricketTeam = gql`
  mutation(
    $PK: String
    $SK: String
    $teamName: String
    $teamShortName: String
    $teamLogo: String
    $teamImage: String
  ) {
    updateCricketTeam(
      input: {
        PK: $PK
        SK: $SK
        teamName: $teamName
        teamShortName: $teamShortName
        teamLogo: $teamLogo
        teamImage: $teamImage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const deleteCricketTeam = gql`
  mutation($PK: String, $SK: String) {
    deleteCricketTeam(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const compressContentImage = gql`
  mutation($imagePath: String) {
    compressContentImage(input: { imagePath: $imagePath }) {
      statusCode
      statusMessage
    }
  }
`

export const clearImageCloudFrontCache = gql`
  mutation($imagePath: String) {
    clearImageCloudFrontCache(input: { imagePath: $imagePath }) {
      statusCode
      statusMessage
    }
  }
`

export const sendContentPushNotification = gql`
  mutation(
    $PK: String
    $SK: String
    $contentLanguage: String
    $pnDescription_Te: String
    $pnDescription_Hi: String
    $pnDescription_En: String
    $pnTitle_Te: String
    $pnTitle_Hi: String
    $pnTitle_En: String
    $bigTextTitle_Te: String
    $bigTextTitle_Hi: String
    $bigTextTitle_En: String
    $pnDescription: String
    $pnTitle: String
    $sendPushNotification: Boolean
    $sendPNWithImage: Boolean
    $sendPNWithBigText: Boolean
    $bigTextTitle: String
    $pnPriority: String
  ) {
    sendContentPushNotification(
      input: {
        PK: $PK
        SK: $SK
        contentLanguage: $contentLanguage
        pnDescription_Te: $pnDescription_Te
        pnDescription_Hi: $pnDescription_Hi
        pnDescription_En: $pnDescription_En
        pnTitle_Te: $pnTitle_Te
        pnTitle_Hi: $pnTitle_Hi
        pnTitle_En: $pnTitle_En
        bigTextTitle_Te: $bigTextTitle_Te
        bigTextTitle_Hi: $bigTextTitle_Hi
        bigTextTitle_En: $bigTextTitle_En
        pnDescription: $pnDescription
        pnTitle: $pnTitle
        sendPushNotification: $sendPushNotification
        sendPNWithImage: $sendPNWithImage
        sendPNWithBigText: $sendPNWithBigText
        bigTextTitle: $bigTextTitle
        pnPriority: $pnPriority
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const UpdateStickyPosition = gql`
  mutation(
    $PK: String
    $SK: String
    $isPushRankEdited: Boolean
    $pushRankUpTo: Int
    $pushRankTo: Int
    $isPushRankActive: Boolean
    $tempPositionFromTop: Int
    $stickyPost: Boolean
    $showSticky: String
    $positionFromTop: Int
    $stickyEndDateTime: Int
    $stickyTargetImpressions: Int
    $isInAppMessage: Boolean
  ) {
    UpdateStickyPosition(
      input: {
        PK: $PK
        SK: $SK
        isPushRankEdited: $isPushRankEdited
        pushRankUpTo: $pushRankUpTo
        pushRankTo: $pushRankTo
        isPushRankActive: $isPushRankActive
        tempPositionFromTop: $tempPositionFromTop
        stickyPost: $stickyPost
        showSticky: $showSticky
        positionFromTop: $positionFromTop
        stickyEndDateTime: $stickyEndDateTime
        stickyTargetImpressions: $stickyTargetImpressions
        isInAppMessage: $isInAppMessage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const registerCompany = gql`
  mutation(
    $companyName: String
    $companyBio: String
    $companyAddress: String
    $companyEmail: String
    $phoneNumber: String
    $GST: String
    $companyLogo: String
    $companyWebsite: String
    $contactName: String
    $jobApplicationLink: String
    $displayMobileNumberInJobPost: Boolean
  ) {
    registerCompany(
      input: {
        companyName: $companyName
        companyBio: $companyBio
        companyAddress: $companyAddress
        companyEmail: $companyEmail
        phoneNumber: $phoneNumber
        GST: $GST
        companyLogo: $companyLogo
        companyWebsite: $companyWebsite
        displayMobileNumberInJobPost: $displayMobileNumberInJobPost
        contactName: $contactName
        jobApplicationLink: $jobApplicationLink
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateRegisteredCompanyDetails = gql`
  mutation(
    $PK: String
    $SK: String
    $companyName: String
    $companyBio: String
    $companyAddress: String
    $companyEmail: String
    $phoneNumber: String
    $GST: String
    $companyWebsite: String
    $companyLogo: String
    $displayMobileNumberInJobPost: Boolean
    $contactName: String
    $jobApplicationLink: String
  ) {
    updateRegisteredCompanyDetails(
      input: {
        PK: $PK
        SK: $SK
        companyName: $companyName
        companyBio: $companyBio
        companyAddress: $companyAddress
        companyEmail: $companyEmail
        phoneNumber: $phoneNumber
        GST: $GST
        companyWebsite: $companyWebsite
        companyLogo: $companyLogo
        displayMobileNumberInJobPost: $displayMobileNumberInJobPost
        contactName: $contactName
        jobApplicationLink: $jobApplicationLink
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateperson = gql`
  mutation(
    $PK: String
    $SK: String
    $about_En: String
    $about_Te: String
    $almamater_En: String
    $almamater_Te: String
    $awards_En: String
    $awards_Te: String
    $birthName_En: String
    $birthName_Te: String
    $children_En: String
    $children_Te: String
    $constituency_En: String
    $constituency_Te: String
    $contentType: String
    $currentlyActive: String
    $dateOfBirth: String
    $died: String
    $education_En: String
    $education_Te: String
    $family_En: String
    $family_Te: String
    $genres_En: String
    $genres_Te: String
    $honours_En: String
    $honours_Te: String
    $imageLink: String
    $instruments_En: String
    $instruments_Te: String
    $labels_En: String
    $labels_Te: String
    $memberOf_En: String
    $memberOf_Te: String
    $name_En: String
    $name_Te: String
    $nationality: String
    $nickName_En: String
    $nickName_Te: String
    $notableWork_En: String
    $notableWork_Te: String
    $occupation_En: String
    $occupation_EnV2: [String]
    $occupation_TeV2: [String]
    $occupation_Te: String
    $occupation_TeV2: [String]
    $origin_En: String
    $origin_Te: String
    $otherNames_En: String
    $otherNames_Te: String
    $birthdayMonthAndDate: String
    $birthYear: String
    $otherPoliticalAffiliations_En: String
    $otherPoliticalAffiliations_Te: String
    $parents_En: String
    $parents_Te: String
    $personID: String
    $personUUID: String
    $personWikiURL: String
    $placeOfBirth_En: String
    $placeOfBirth_Te: String
    $politicalParty_En: String
    $politicalParty_Te: String
    $posterURL: String
    $precededBy_En: String
    $precededBy_Te: String
    $relatives_En: String
    $relatives_Te: String
    $residence_En: String
    $residence_Te: String
    $spouse_En: String
    $spouse_EnV2: [String]
    $spouse_Te: String
    $spouse_TeV2: [String]
    $succeededBy_En: String
    $succeededBy_Te: String
    $title_En: String
    $title_Te: String
    $website: String
    $moderatorID: String
    $moderatorHandle: String
    $works_En: String
    $works_Te: String
    $birthdayMonthAndDate: String
    $birthYear: String
    $yearsActive: String
    $popularPerson: Boolean
    $GOAT: Boolean
    $popularyKnownAs_En: String
    $popularyKnownAs_Te: String
    $galleryImages: [galleryImageVideoInput]
    $galleryVideos: [galleryImageVideoInput]
    $imageUpdatedTime: Int
    $internalComments: String
    $personArticleReviewTitle_En: String
    $personArticleReviewTitle_Te: String
    $yousayPersonReviewURL_Te: String
    $yousayPersonReviewURL_En: String
    $tags: [String]
    $adminTagsGood: [String]
    $adminTagsBad: [String]
    $personNewsUpdates: [personNewsUpdatesInput]
    $yousayArticleReviews: [yousayArticleReviewsInput]
  ) {
    updatePerson(
      input: {
        PK: $PK
        SK: $SK
        personNewsUpdates: $personNewsUpdates
        internalComments: $internalComments
        about_En: $about_En
        about_Te: $about_Te
        tags: $tags
        adminTagsGood: $adminTagsGood
        adminTagsBad: $adminTagsBad
        yousayArticleReviews: $yousayArticleReviews
        personArticleReviewTitle_En: $personArticleReviewTitle_En
        personArticleReviewTitle_Te: $personArticleReviewTitle_Te
        yousayPersonReviewURL_Te: $yousayPersonReviewURL_Te
        yousayPersonReviewURL_En: $yousayPersonReviewURL_En
        almamater_En: $almamater_En
        almamater_Te: $almamater_Te
        awards_En: $awards_En
        awards_Te: $awards_Te
        birthName_En: $birthName_En
        birthName_Te: $birthName_Te
        children_En: $children_En
        children_Te: $children_Te
        constituency_En: $constituency_En
        constituency_Te: $constituency_Te
        contentType: $contentType
        currentlyActive: $currentlyActive
        dateOfBirth: $dateOfBirth
        died: $died
        birthdayMonthAndDate: $birthdayMonthAndDate
        birthYear: $birthYear
        education_En: $education_En
        education_Te: $education_Te
        family_En: $family_En
        family_Te: $family_Te
        genres_En: $genres_En
        genres_Te: $genres_Te
        honours_En: $honours_En
        honours_Te: $honours_Te
        imageLink: $imageLink
        instruments_En: $instruments_En
        instruments_Te: $instruments_Te
        labels_En: $labels_En
        labels_Te: $labels_Te
        memberOf_En: $memberOf_En
        memberOf_Te: $memberOf_Te
        name_En: $name_En
        name_Te: $name_Te
        nationality: $nationality
        nickName_En: $nickName_En
        nickName_Te: $nickName_Te
        notableWork_En: $notableWork_En
        notableWork_Te: $notableWork_Te
        occupation_En: $occupation_En
        occupation_EnV2: $occupation_EnV2
        occupation_TeV2: $occupation_TeV2
        occupation_Te: $occupation_Te
        occupation_TeV2: $occupation_TeV2
        origin_En: $origin_En
        origin_Te: $origin_Te
        otherNames_En: $otherNames_En
        otherNames_Te: $otherNames_Te
        otherPoliticalAffiliations_En: $otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te: $otherPoliticalAffiliations_Te
        parents_En: $parents_En
        parents_Te: $parents_Te
        personID: $personID
        personUUID: $personUUID
        personWikiURL: $personWikiURL
        placeOfBirth_En: $placeOfBirth_En
        placeOfBirth_Te: $placeOfBirth_Te
        politicalParty_En: $politicalParty_En
        politicalParty_Te: $politicalParty_Te
        posterURL: $posterURL
        precededBy_En: $precededBy_En
        precededBy_Te: $precededBy_Te
        relatives_En: $relatives_En
        relatives_Te: $relatives_Te
        residence_En: $residence_En
        residence_Te: $residence_Te
        spouse_En: $spouse_En
        spouse_EnV2: $spouse_EnV2
        spouse_TeV2: $spouse_TeV2
        spouse_Te: $spouse_Te
        spouse_EnV2: $spouse_EnV2
        spouse_TeV2: $spouse_TeV2
        succeededBy_En: $succeededBy_En
        succeededBy_Te: $succeededBy_Te
        title_En: $title_En
        title_Te: $title_Te
        imageUpdatedTime: $imageUpdatedTime
        website: $website
        works_En: $works_En
        works_Te: $works_Te
        yearsActive: $yearsActive
        popularPerson: $popularPerson
        GOAT: $GOAT
        popularyKnownAs_En: $popularyKnownAs_En
        popularyKnownAs_Te: $popularyKnownAs_Te
        galleryImages: $galleryImages
        galleryVideos: $galleryVideos
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updatepersonstatus = gql`
  mutation($PK: String!, $SK: String!, $status: String!) {
    updatePersonStatus(
      input: {
        PK: $PK
        SK: $SK
        status: $status
        moderatorID: "moderatorID"
        moderatorHandle: "@moderatorHandle"
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const unregisterCompany = gql`
  mutation($PK: String, $SK: String) {
    unregisterCompany(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const updateMovie = gql`
  mutation(
    $PK: String!
    $popularMovie: Boolean
    $GOAT: Boolean
    $originalLanguageTelugu: Boolean
    $SK: String!
    $about_En: String
    $about_Te: String
    $ageRestriction: String
    $ahaLink: String
    $basedOn_En: String
    $basedOn_Te: String
    $boxOffice: String
    $budget: String
    $contentType: String!
    $country: String
    $distributedBy_En: String
    $distributedBy_Te: String
    $etvApp: String
    $genre_En: [String]
    $hotstarLink: String
    $imageLink: String
    $language: String
    $movieID: String!
    $movieRating: Float
    $movieReleasedDate: Int
    $narratedBy_En: String
    $narratedBy_Te: String
    $netflixLink: String
    $ottPlatform: [String]
    $ottReleasedDate: Int
    $ottReleasedDateUI: String
    $posterURL: String
    $primeLink: String
    $productionCompany_En: String
    $productionCompany_Te: String
    $runningTime: String
    $sonyLiv: String
    $sunNextLink: String
    $title_En: String
    $title_Te: String
    $yousayRating: Float
    $movieArticleReviewTitle_En: String
    $movieArticleReviewTitle_Te: String
    $wikipediaLink: String
    $youtubeLink: String
    $zee5Link: String
    $jioCinemaLink: String
    $mxPlayer: String
    $updateCombinations: Boolean
    $updateCrew: Boolean
    $updateCast: Boolean
    $movieReleasedDateUI: String
    $cast: [updateCastInput]
    $crew: [updateCrewInput]
    $moderatorID: String
    $moderatorHandle: String
    $deleteFields: [String]
    $noOfEpisodes: Int
    $yousayMovieReviewURL_Te: String
    $yousayMovieReviewURL_En: String
    $galleryImages: [galleryImageVideoInput]
    $galleryVideos: [galleryImageVideoInput]
    $imageUpdatedTime: Int
    $movieAndOTTNewsUpdates: [movieAndOTTNewsInput]
    $internalComments: String
    $movieStatus: movieStatusInput
    $OTTStatus: OTTStatusInput
    $OTTPlatformsWithLangs: [OTTPlatformsWithLangsInput]
    $tags: [String]
    $adminTagsGood: [String]
    $adminTagsBad: [String]
    $yousayArticleReviews: [yousayArticleReviewsInput]
    $sendTFIDBPN: Boolean
    $PNInfo: PNInfoInput
  ) {
    updateMovie(
      input: {
        PK: $PK
        SK: $SK
        tags: $tags
        sendTFIDBPN: $sendTFIDBPN
        PNInfo: $PNInfo
        yousayArticleReviews: $yousayArticleReviews
        adminTagsGood: $adminTagsGood
        adminTagsBad: $adminTagsBad
        OTTPlatformsWithLangs: $OTTPlatformsWithLangs
        OTTStatus: $OTTStatus
        movieStatus: $movieStatus
        internalComments: $internalComments
        popularMovie: $popularMovie
        movieAndOTTNewsUpdates: $movieAndOTTNewsUpdates
        originalLanguageTelugu: $originalLanguageTelugu
        GOAT: $GOAT
        movieArticleReviewTitle_En: $movieArticleReviewTitle_En
        movieArticleReviewTitle_Te: $movieArticleReviewTitle_Te
        about_En: $about_En
        about_Te: $about_Te
        ageRestriction: $ageRestriction
        ahaLink: $ahaLink
        yousayRating: $yousayRating
        movieReleasedDateUI: $movieReleasedDateUI
        basedOn_En: $basedOn_En
        basedOn_Te: $basedOn_Te
        boxOffice: $boxOffice
        budget: $budget
        contentType: $contentType
        country: $country
        cast: $cast
        crew: $crew
        distributedBy_En: $distributedBy_En
        distributedBy_Te: $distributedBy_Te
        etvApp: $etvApp
        genre_En: $genre_En
        hotstarLink: $hotstarLink
        imageLink: $imageLink
        language: $language
        movieID: $movieID
        movieRating: $movieRating
        movieReleasedDate: $movieReleasedDate
        narratedBy_En: $narratedBy_En
        narratedBy_Te: $narratedBy_Te
        netflixLink: $netflixLink
        mxPlayer: $mxPlayer
        ottPlatform: $ottPlatform
        ottReleasedDate: $ottReleasedDate
        ottReleasedDateUI: $ottReleasedDateUI
        posterURL: $posterURL
        primeLink: $primeLink
        productionCompany_En: $productionCompany_En
        productionCompany_Te: $productionCompany_Te
        runningTime: $runningTime
        sonyLiv: $sonyLiv
        sunNextLink: $sunNextLink
        title_En: $title_En
        title_Te: $title_Te
        wikipediaLink: $wikipediaLink
        youtubeLink: $youtubeLink
        jioCinemaLink: $jioCinemaLink
        zee5Link: $zee5Link
        updateCombinations: $updateCombinations
        updateCrew: $updateCrew
        updateCast: $updateCast
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        deleteFields: $deleteFields
        noOfEpisodes: $noOfEpisodes
        yousayMovieReviewURL_Te: $yousayMovieReviewURL_Te
        yousayMovieReviewURL_En: $yousayMovieReviewURL_En
        galleryImages: $galleryImages
        galleryVideos: $galleryVideos
        imageUpdatedTime: $imageUpdatedTime
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const updateMovieStatus = gql`
  mutation(
    $PK: String!
    $SK: String!
    $status: String!
    $moderatorID: String
    $moderatorHandle: String
    $sendTFIDBPN: Boolean
  ) {
    updateMovieStatus(
      input: {
        PK: $PK
        SK: $SK
        status: $status
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        sendTFIDBPN: $sendTFIDBPN
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const importMovies = gql`
  mutation(
    $s3path: String!
    $contentType: String!
    $moderatorID: String!
    $moderatorHandle: String!
  ) {
    importMovies(
      input: {
        s3path: $s3path
        contentType: $contentType
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const DeleteMovieListService = gql`
  mutation($PK: String!, $SK: String!) {
    deleteMovieList(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const createMovieList = gql`
  mutation(
    $createdByHandle: String!
    $createdByID: String!
    $description_En: String!
    $movieListCategory: movieListCategory!
    $movieListType: movieListType!
    $movieListID: String!
    $title_En: String!
    $title_Te: String!
    $description_Te: String
    $movieListImage: String
  ) {
    createMovieList(
      input: {
        createdByHandle: $createdByHandle
        createdByID: $createdByID
        description_En: $description_En
        description_Te: $description_Te
        movieListCategory: $movieListCategory
        movieListType: $movieListType
        movieListID: $movieListID
        title_En: $title_En
        title_Te: $title_Te
        movieListImage: $movieListImage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const updateMovieListData = gql`
  mutation(
    $movieListID: String!
    $movieListCategory: movieListCategory!
    $addedByID: String!
    $addedByHandle: String!
    $movieOrPersonInfo: [movieOrPersonInfoInput]!
  ) {
    updateMovieListData(
      input: {
        movieListID: $movieListID
        movieListCategory: $movieListCategory
        addedByID: $addedByID
        addedByHandle: $addedByHandle
        movieOrPersonInfo: $movieOrPersonInfo
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const tagPersonsToMovieList = gql`
  mutation(
    $movieListID: String!
    $addedByID: String!
    $addedByHandle: String!
    $personIDs: [String]!
  ) {
    tagPersonsToMovieList(
      input: {
        movieListID: $movieListID
        addedByID: $addedByID
        addedByHandle: $addedByHandle
        personIDs: $personIDs
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const mergePersonsService = gql`
  mutation mergePersons($person1: String!, $person2: String!) {
    mergePersons(input: { person1: $person1, person2: $person2 }) {
      statusCode
      statusMessage
    }
  }
`
//
export const createMovie = gql`
  mutation(
    $contentType: String!
    $createdById: String!
    $popularMovie: Boolean
    $movieArticleReviewTitle_En: String
    $movieArticleReviewTitle_Te: String
    $createdByHandle: String!
    $wikipediaLink: String!
    $title_En: String!
    $title_Te: String!
    $ageRestriction: String!
    $about_En: String!
    $about_Te: String!
    $boxOffice: String
    $budget: String
    $country: String
    $basedOn_En: String
    $basedOn_Te: String
    $distributedBy_Te: String
    $distributedBy_En: String
    $genre_En: [String]
    $imageLink: String
    $language: String
    $movieReleasedDate: Int
    $movieReleasedDateUI: String
    $narratedBy_En: String
    $narratedBy_Te: String
    $ottPlatform: [String]
    $ottReleasedDate: Int
    $ottReleasedDateUI: String
    $yousayRating: Float
    $posterURL: String!
    $productionCompany_En: String
    $productionCompany_Te: String
    $movieRating: Float
    $youtubeLink: String
    $zee5Link: String
    $sunNextLink: String
    $sonyLiv: String
    $primeLink: String
    $netflixLink: String
    $hotstarLink: String
    $jioCinemaLink: String
    $etvApp: String
    $ahaLink: String
    $runningTime: String
    $noOfEpisodes: Int
    $cast: [createCastInput]!
    $crew: [createCrewInput]!
    $yousayMovieReviewURL_Te: String
    $yousayMovieReviewURL_En: String
    $mxPlayer: String
    $galleryImages: [galleryImageVideoInput]
    $galleryVideos: [galleryImageVideoInput]
    $GOAT: Boolean
    $originalLanguageTelugu: Boolean
    $internalComments: String
    $movieStatus: movieStatusInput
    $OTTStatus: OTTStatusInput
    $OTTPlatformsWithLangs: [OTTPlatformsWithLangsInput]
    $yousayArticleReviews: [yousayArticleReviewsInput]
    $PNInfo: PNInfoInput
    $sendTFIDBPN: Boolean
  ) {
    createMovie(
      input: {
        sendTFIDBPN: $sendTFIDBPN
        PNInfo: $PNInfo
        yousayArticleReviews: $yousayArticleReviews
        OTTPlatformsWithLangs: $OTTPlatformsWithLangs
        OTTStatus: $OTTStatus
        movieStatus: $movieStatus
        internalComments: $internalComments
        popularMovie: $popularMovie
        originalLanguageTelugu: $originalLanguageTelugu
        contentType: $contentType
        createdById: $createdById
        createdByHandle: $createdByHandle
        wikipediaLink: $wikipediaLink
        title_En: $title_En
        title_Te: $title_Te
        yousayRating: $yousayRating
        ageRestriction: $ageRestriction
        movieArticleReviewTitle_En: $movieArticleReviewTitle_En
        movieArticleReviewTitle_Te: $movieArticleReviewTitle_Te
        about_En: $about_En
        about_Te: $about_Te
        boxOffice: $boxOffice
        budget: $budget
        country: $country
        distributedBy_Te: $distributedBy_Te
        distributedBy_En: $distributedBy_En
        genre_En: $genre_En
        imageLink: $imageLink
        language: $language
        movieReleasedDate: $movieReleasedDate
        movieReleasedDateUI: $movieReleasedDateUI
        narratedBy_En: $narratedBy_En
        narratedBy_Te: $narratedBy_Te
        ottPlatform: $ottPlatform
        mxPlayer: $mxPlayer
        basedOn_En: $basedOn_En
        basedOn_Te: $basedOn_Te
        ottReleasedDate: $ottReleasedDate
        ottReleasedDateUI: $ottReleasedDateUI
        posterURL: $posterURL
        productionCompany_En: $productionCompany_En
        productionCompany_Te: $productionCompany_Te
        movieRating: $movieRating
        youtubeLink: $youtubeLink
        zee5Link: $zee5Link
        sunNextLink: $sunNextLink
        sonyLiv: $sonyLiv
        primeLink: $primeLink
        netflixLink: $netflixLink
        hotstarLink: $hotstarLink
        etvApp: $etvApp
        ahaLink: $ahaLink
        runningTime: $runningTime
        noOfEpisodes: $noOfEpisodes
        jioCinemaLink: $jioCinemaLink
        cast: $cast
        crew: $crew
        yousayMovieReviewURL_Te: $yousayMovieReviewURL_Te
        yousayMovieReviewURL_En: $yousayMovieReviewURL_En
        galleryImages: $galleryImages
        galleryVideos: $galleryVideos
        GOAT: $GOAT
      }
    ) {
      statusCode
      statusMessage
      PK
      SK
    }
  }
`
export const createPerson = gql`
  mutation(
    $about_En: String!
    $about_Te: String!
    $name_En: String!
    $name_Te: String!
    $personType: String!
    $personWikiURL: String!
    $almamater_En: String
    $almamater_Te: String
    $awards_En: String
    $awards_Te: String
    $popularPerson: Boolean
    $GOAT: Boolean
    $popularyKnownAs_En: String
    $popularyKnownAs_Te: String
    $birthName_En: String
    $birthName_Te: String
    $birthdayMonthAndDate: String
    $birthYear: String
    $children_En: String
    $children_Te: String
    $constituency_En: String
    $constituency_Te: String
    $currentlyActive: String
    $dateOfBirth: String
    $died: String
    $education_En: String
    $education_Te: String
    $family_En: String
    $family_Te: String
    $genres_En: String
    $genres_Te: String
    $honours_En: String
    $honours_Te: String
    $imageLink: String
    $instruments_En: String
    $instruments_Te: String
    $labels_En: String
    $labels_Te: String
    $memberOf_En: String
    $memberOf_Te: String
    $nationality: String
    $nickName_En: String
    $nickName_Te: String
    $notableWork_En: String
    $notableWork_Te: String
    $occupation_En: String
    $occupation_EnV2: [String]
    $occupation_Te: String
    $occupation_TeV2: [String]
    $origin_En: String
    $origin_Te: String
    $otherNames_En: String
    $otherNames_Te: String
    $otherPoliticalAffiliations_En: String
    $otherPoliticalAffiliations_Te: String
    $parents_En: String
    $parents_Te: String
    $personUUID: String
    $placeOfBirth_En: String
    $placeOfBirth_Te: String
    $politicalParty_En: String
    $politicalParty_Te: String
    $posterURL: String!
    $precededBy_En: String
    $precededBy_Te: String
    $relatives_En: String
    $relatives_Te: String
    $residence_En: String
    $residence_Te: String
    $spouse_En: String
    $spouse_EnV2: [String]
    $spouse_Te: String
    $spouse_TeV2: [String]
    $succeededBy_En: String
    $succeededBy_Te: String
    $title_En: String
    $title_Te: String
    $website: String
    $works_En: String
    $works_Te: String
    $yearsActive: String
    $galleryImages: [galleryImageVideoInput]
    $galleryVideos: [galleryImageVideoInput]
    $moderatorID: String!
    $imageUpdatedTime: Int
    $moderatorHandle: String!
    $internalComments: String
    $personArticleReviewTitle_En: String
    $personArticleReviewTitle_Te: String
    $yousayPersonReviewURL_Te: String
    $yousayPersonReviewURL_En: String
  ) {
    createPerson(
      input: {
        personArticleReviewTitle_En: $personArticleReviewTitle_En
        personArticleReviewTitle_Te: $personArticleReviewTitle_Te
        yousayPersonReviewURL_Te: $yousayPersonReviewURL_Te
        yousayPersonReviewURL_En: $yousayPersonReviewURL_En
        internalComments: $internalComments
        about_En: $about_En
        about_Te: $about_Te
        name_En: $name_En
        name_Te: $name_Te
        personType: $personType
        personWikiURL: $personWikiURL
        almamater_En: $almamater_En
        almamater_Te: $almamater_Te
        awards_En: $awards_En
        awards_Te: $awards_Te
        birthName_En: $birthName_En
        birthName_Te: $birthName_Te
        birthdayMonthAndDate: $birthdayMonthAndDate
        birthYear: $birthYear
        children_En: $children_En
        children_Te: $children_Te
        constituency_En: $constituency_En
        constituency_Te: $constituency_Te
        currentlyActive: $currentlyActive
        dateOfBirth: $dateOfBirth
        died: $died
        popularPerson: $popularPerson
        GOAT: $GOAT
        popularyKnownAs_En: $popularyKnownAs_En
        popularyKnownAs_Te: $popularyKnownAs_Te
        education_En: $education_En
        education_Te: $education_Te
        family_En: $family_En
        family_Te: $family_Te
        genres_En: $genres_En
        genres_Te: $genres_Te
        honours_En: $honours_En
        honours_Te: $honours_Te
        imageLink: $imageLink
        instruments_En: $instruments_En
        instruments_Te: $instruments_Te
        labels_En: $labels_En
        labels_Te: $labels_Te
        memberOf_En: $memberOf_En
        memberOf_Te: $memberOf_Te
        nationality: $nationality
        nickName_En: $nickName_En
        nickName_Te: $nickName_Te
        notableWork_En: $notableWork_En
        notableWork_Te: $notableWork_Te
        occupation_En: $occupation_En
        occupation_EnV2: $occupation_EnV2
        occupation_Te: $occupation_Te
        occupation_TeV2: $occupation_TeV2
        origin_En: $origin_En
        origin_Te: $origin_Te
        otherNames_En: $otherNames_En
        otherNames_Te: $otherNames_Te
        otherPoliticalAffiliations_En: $otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te: $otherPoliticalAffiliations_Te
        parents_En: $parents_En
        parents_Te: $parents_Te
        personUUID: $personUUID
        placeOfBirth_En: $placeOfBirth_En
        placeOfBirth_Te: $placeOfBirth_Te
        politicalParty_En: $politicalParty_En
        politicalParty_Te: $politicalParty_Te
        posterURL: $posterURL
        precededBy_En: $precededBy_En
        precededBy_Te: $precededBy_Te
        relatives_En: $relatives_En
        relatives_Te: $relatives_Te
        residence_En: $residence_En
        residence_Te: $residence_Te
        spouse_En: $spouse_En
        spouse_EnV2: $spouse_EnV2
        spouse_Te: $spouse_Te
        spouse_TeV2: $spouse_TeV2
        succeededBy_En: $succeededBy_En
        succeededBy_Te: $succeededBy_Te
        title_En: $title_En
        title_Te: $title_Te
        website: $website
        works_En: $works_En
        works_Te: $works_Te
        imageUpdatedTime: $imageUpdatedTime
        galleryImages: $galleryImages
        galleryVideos: $galleryVideos
        yearsActive: $yearsActive
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
      }
    ) {
      statusCode
      statusMessage
      PK
      SK
    }
  }
`

export const updateUserRolesPermissions = gql`
  mutation(
    $PK: String!
    $SK: String!
    $roles: [String]
    $removedRoles: [String]
    $userRolesAndPermissions: [rolesAndPermissionsInput]
  ) {
    updateUserRolesAndPermissions(
      input: {
        PK: $PK
        SK: $SK
        roles: $roles
        removedRoles: $removedRoles
        userRolesAndPermissions: $userRolesAndPermissions
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateMovieList = gql`
  mutation(
    $description_En: String!
    $PK: String!
    $SK: String!
    $title_En: String!
    $title_Te: String!
    $description_Te: String!
    $movieListImage: String
  ) {
    updateMovieList(
      input: {
        PK: $PK
        SK: $SK
        description_En: $description_En
        description_Te: $description_Te
        title_En: $title_En
        title_Te: $title_Te
        movieListImage: $movieListImage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const untagPersonsFromMovieList = gql`
  mutation($movieListID: String!, $personIDs: [String]!) {
    untagPersonsFromMovieList(input: { movieListID: $movieListID, personIDs: $personIDs }) {
      statusCode
      statusMessage
    }
  }
`
export const createMovieCollection = gql`
  mutation(
    $title_En: String!
    $title_Te: String!
    $description_En: String!
    $description_Te: String!
    $moderatorID: String!
    $moderatorHandle: String!
    $movieCollectionImage: String
  ) {
    createMovieCollection(
      input: {
        title_En: $title_En
        title_Te: $title_Te
        description_En: $description_En
        description_Te: $description_Te
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        movieCollectionImage: $movieCollectionImage
      }
    ) {
      PK
      SK
      statusCode
      statusMessage
    }
  }
`
export const deleteMovieCollection = gql`
  mutation($PK: String!, $SK: String!) {
    deleteMovieCollection(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`
export const updateMovieCollectionDataV2 = gql`
  mutation(
    $movieCollectionID: String!
    $listsInfo: [updateMovieCollectionDataV2ListsInfoInput]!
    $moderatorID: String!
    $moderatorHandle: String!
  ) {
    updateMovieCollectionDataV2(
      input: {
        movieCollectionID: $movieCollectionID
        listsInfo: $listsInfo
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateMovieCollection = gql`
  mutation(
    $PK: String!
    $SK: String!
    $title_En: String!
    $title_Te: String!
    $description_En: String!
    $description_Te: String!
    $moderatorID: String!
    $moderatorHandle: String!
    $movieCollectionImage: String!
  ) {
    updateMovieCollection(
      input: {
        PK: $PK
        SK: $SK
        title_En: $title_En
        title_Te: $title_Te
        description_En: $description_En
        description_Te: $description_Te
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        movieCollectionImage: $movieCollectionImage
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateCollectionStatus = gql`
  mutation($movieCollectionID: String!, $status: statusType!) {
    updateCollectionStatus(input: { movieCollectionID: $movieCollectionID, status: $status }) {
      statusCode
      statusMessage
    }
  }
`
export const updateMovieListStatus = gql`
  mutation($movieListID: String!, $status: statusType!) {
    updateMovieListStatus(input: { movieListID: $movieListID, status: $status }) {
      statusCode
      statusMessage
    }
  }
`
export const tagPersonsAtHeaderLevelToMovieList = gql`
  mutation(
    $movieListID: String!
    $addedByID: String!
    $addedByHandle: String!
    $personIDs: [String]!
  ) {
    tagPersonsAtHeaderLevelToMovieList(
      input: {
        movieListID: $movieListID
        addedByID: $addedByID
        addedByHandle: $addedByHandle
        personIDs: $personIDs
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const untagPersonsAtHeaderLevelFromMovieList = gql`
  mutation($movieListID: String!, $personIDs: [String]!) {
    untagPersonsAtHeaderLevelFromMovieList(
      input: { movieListID: $movieListID, personIDs: $personIDs }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const tagPersonsAtHeaderLevelToMovieCollection = gql`
  mutation(
    $movieCollectionID: String!
    $addedByID: String!
    $addedByHandle: String!
    $personIDs: [String]!
  ) {
    tagPersonsAtHeaderLevelToMovieCollection(
      input: {
        movieCollectionID: $movieCollectionID
        addedByID: $addedByID
        addedByHandle: $addedByHandle
        personIDs: $personIDs
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const untagPersonsAtHeaderLevelFromMovieCollection = gql`
  mutation($movieCollectionID: String!, $personIDs: [String]!) {
    untagPersonsAtHeaderLevelFromMovieCollection(
      input: { movieCollectionID: $movieCollectionID, personIDs: $personIDs }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const createDynamicList = gql`
  mutation(
    $movieID: String
    $personID: String
    $directedBy_En: [String]
    $cinematography_En: [String]
    $editedBy_En: [String]
    $musicBy_En: [String]
    $producedBy_En: [String]
    $writtenBy_En: [String]
    $dialogueBy_En: [String]
    $screenplayBy_En: [String]
    $storyBy_En: [String]
    $cast_En: [String]
    $moderatorID: String!
    $moderatorHandle: String!
    $title_En: String!
    $title_Te: String!
    $description_En: String
    $description_Te: String
    $dynamicListImage: String
    $dynamicListType: dynamicListType!
    $contentType: contentType
    $sortBy: dynamicListSortBy
    $genre_En: [String]
    $genre_Te: [String]
    $ottPlatform: [OTTPlatform]
    $ageRestriction: String
    $movieRating: Int
    $fromDate: Int
    $toDate: Int
    $fromRating: Float
    $toRating: Float
    $popularListType: dynamicListPopularListType
    $popularListCategory: dynamicListPopularListCategory
    $viewsType: dynamicListViewsAndLikesType
    $likesType: dynamicListViewsAndLikesType
    $crewFilterBy: String
    $castFilterBy: String
    $limit: Int
    $fromRatingV2: Int
    $toRatingV2: Int
  ) {
    createDynamicList(
      input: {
        personID: $personID
        movieID: $movieID
        crewFilterBy: $crewFilterBy
        castFilterBy: $castFilterBy
        directedBy_En: $directedBy_En
        cinematography_En: $cinematography_En
        editedBy_En: $editedBy_En
        musicBy_En: $musicBy_En
        producedBy_En: $producedBy_En
        writtenBy_En: $writtenBy_En
        dialogueBy_En: $dialogueBy_En
        screenplayBy_En: $screenplayBy_En
        storyBy_En: $storyBy_En
        cast_En: $cast_En
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        title_En: $title_En
        title_Te: $title_Te
        description_En: $description_En
        description_Te: $description_Te
        dynamicListImage: $dynamicListImage
        dynamicListType: $dynamicListType
        contentType: $contentType
        sortBy: $sortBy
        genre_En: $genre_En
        genre_Te: $genre_Te
        ottPlatform: $ottPlatform
        ageRestriction: $ageRestriction
        movieRating: $movieRating
        fromDate: $fromDate
        toDate: $toDate
        fromRating: $fromRating
        toRating: $toRating
        popularListType: $popularListType
        popularListCategory: $popularListCategory
        viewsType: $viewsType
        likesType: $likesType
        limit: $limit
        fromRatingV2: $fromRatingV2
        toRatingV2: $toRatingV2
      }
    ) {
      PK
      SK
      statusCode
      statusMessage
    }
  }
`
export const deleteDynamicList = gql`
  mutation($PK: String!, $SK: String!) {
    deleteDynamicList(input: { PK: $PK, SK: $SK }) {
      statusCode
      statusMessage
    }
  }
`

export const updateDynamicList = gql`
  mutation(
    $PK: String!
    $SK: String!
    $movieID: String
    $personID: String
    $moderatorID: String!
    $moderatorHandle: String!
    $title_En: String!
    $title_Te: String!
    $description_En: String!
    $description_Te: String!
    $dynamicListImage: String!
    $dynamicListType: dynamicListType!
    $contentType: contentType
    $sortBy: dynamicListSortBy
    $genre_En: [String]
    $genre_Te: [String]
    $ottPlatform: [OTTPlatform]
    $ageRestriction: String
    $movieRating: Int
    $fromDate: Int
    $toDate: Int
    $fromRating: Float
    $fromRatingV2: Int
    $toRating: Float
    $toRatingV2: Int
    $popularListType: dynamicListPopularListType
    $popularListCategory: dynamicListPopularListCategory
    $viewsType: dynamicListViewsAndLikesType
    $likesType: dynamicListViewsAndLikesType
    $directedBy_En: [String]
    $cinematography_En: [String]
    $editedBy_En: [String]
    $musicBy_En: [String]
    $producedBy_En: [String]
    $writtenBy_En: [String]
    $dialogueBy_En: [String]
    $screenplayBy_En: [String]
    $storyBy_En: [String]
    $cast_En: [String]
    $crewFilterBy: String
    $castFilterBy: String
    $limit: Int
  ) {
    updateDynamicList(
      input: {
        PK: $PK
        SK: $SK
        personID: $personID
        movieID: $movieID
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        crewFilterBy: $crewFilterBy
        castFilterBy: $castFilterBy
        title_En: $title_En
        title_Te: $title_Te
        description_En: $description_En
        description_Te: $description_Te
        dynamicListImage: $dynamicListImage
        dynamicListType: $dynamicListType
        contentType: $contentType
        sortBy: $sortBy
        genre_En: $genre_En
        genre_Te: $genre_Te
        ottPlatform: $ottPlatform
        ageRestriction: $ageRestriction
        movieRating: $movieRating
        fromDate: $fromDate
        toDate: $toDate
        fromRating: $fromRating
        fromRatingV2: $fromRatingV2
        toRating: $toRating
        toRatingV2: $toRatingV2
        popularListType: $popularListType
        popularListCategory: $popularListCategory
        viewsType: $viewsType
        likesType: $likesType
        directedBy_En: $directedBy_En
        cinematography_En: $cinematography_En
        editedBy_En: $editedBy_En
        musicBy_En: $musicBy_En
        producedBy_En: $producedBy_En
        writtenBy_En: $writtenBy_En
        dialogueBy_En: $dialogueBy_En
        screenplayBy_En: $screenplayBy_En
        storyBy_En: $storyBy_En
        cast_En: $cast_En
        limit: $limit
      }
    ) {
      PK
      SK
      statusCode
      statusMessage
    }
  }
`
export const tagPersonsAtHeaderLevelToDynamicList = gql`
  mutation(
    $dynamicListID: String!
    $addedByID: String!
    $addedByHandle: String!
    $personIDs: [String]!
  ) {
    tagPersonsAtHeaderLevelToDynamicList(
      input: {
        dynamicListID: $dynamicListID
        addedByID: $addedByID
        addedByHandle: $addedByHandle
        personIDs: $personIDs
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const untagPersonsAtHeaderLevelFromDynamicList = gql`
  mutation($dynamicListID: String!, $personIDs: [String]!) {
    untagPersonsAtHeaderLevelFromDynamicList(
      input: { dynamicListID: $dynamicListID, personIDs: $personIDs }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updateDynamicListStatus = gql`
  mutation($dynamicListID: String!, $status: statusType!) {
    updateDynamicListStatus(input: { dynamicListID: $dynamicListID, status: $status }) {
      statusCode
      statusMessage
    }
  }
`
export const updateTFIDBPageJSONService = gql`
  mutation updateTFIDBPageJSON(
    $PK: String!
    $SK: String!
    $moderatorHandle: String!
    $moderatorID: String!
    $JSON: [updateTFIDBPageJSONDataInput]
  ) {
    updateTFIDBPageJSON(
      input: {
        PK: $PK
        SK: $SK
        moderatorHandle: $moderatorHandle
        moderatorID: $moderatorID
        JSON: $JSON
      }
    ) {
      statusCode
      statusMessage
    }
  }
`

export const updatePointsToMovieOrPerson = gql`
  mutation updatePointsToMovieOrPerson(
    $contentType: pointsContentType!
    $id: String!
    $recordType: pointsTypeForMovieOrPerson!
    $points: Int!
  ) {
    updatePointsToMovieOrPerson(
      contentType: $contentType
      id: $id
      recordType: $recordType
      points: $points
    ) {
      statusCode
      statusMessage
    }
  }
`
export const updatePointsForTrendingData = gql`
  mutation($items: [updatePointsForTrendingDataInput]) {
    updatePointsForTrendingData(input: { items: $items }) {
      statusCode
      statusMessage
    }
  }
`

export const updatePersonExtendedInfo = gql`
  mutation updatePersonExtendedInfo(
    $PK: String!
    $SK: String!
    $instagramLink: String
    $twitterID: String
    $age: Int
    $education_TFIDB: String
    $height: String
    $awards_TFIDB: [String]
    $firstMovie: updatePersonExtendedInfoMovieIDInput
    $firstSuccessfulMovie: updatePersonExtendedInfoMovieIDInput
    $hitMovies: [updatePersonExtendedInfoMovieIDInput]
    $readMoreAboutLink: String
    $spouse_TFIDB: [updatePersonExtendedInfoTFIDBInput]
    $parents_TFIDB: [updatePersonExtendedInfoTFIDBInput]
    $relatives_TFIDB: [updatePersonExtendedInfoTFIDBInput]
    $children_TFIDB: [updatePersonExtendedInfoTFIDBInput]
    $career: careerPersonExtendedInfoInput
    $favourites: favouritesPersonExtendedInfoInput
    $personalAndBackgroundInfo: personalAndBackgroundInfoInput
    $personalAssetsAndSocialMedia: personalAssetsAndSocialMediaInput
    $politicsInfo: politicsInfoInput
    $businessVentures: businessVenturesInput
    $rumorsAndControversies: rumorsAndControversiesInput
    $familyAndRelationships: familyAndRelationshipsInput
    $achievementsAndHonors: achievementsAndHonorsInput
    $moderatorID: String!
    $moderatorHandle: String!
  ) {
    updatePersonExtendedInfo(
      input: {
        PK: $PK
        SK: $SK
        career: $career
        favourites: $favourites
        moderatorID: $moderatorID
        moderatorHandle: $moderatorHandle
        age: $age
        instagramLink: $instagramLink
        twitterID: $twitterID
        education_TFIDB: $education_TFIDB
        height: $height
        awards_TFIDB: $awards_TFIDB
        firstMovie: $firstMovie
        firstSuccessfulMovie: $firstSuccessfulMovie
        hitMovies: $hitMovies
        readMoreAboutLink: $readMoreAboutLink
        spouse_TFIDB: $spouse_TFIDB
        parents_TFIDB: $parents_TFIDB
        relatives_TFIDB: $relatives_TFIDB
        children_TFIDB: $children_TFIDB
        personalAndBackgroundInfo: $personalAndBackgroundInfo
        personalAssetsAndSocialMedia: $personalAssetsAndSocialMedia
        politicsInfo: $politicsInfo
        businessVentures: $businessVentures
        rumorsAndControversies: $rumorsAndControversies
        familyAndRelationships: $familyAndRelationships
        achievementsAndHonors: $achievementsAndHonors
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const CreateTagMutation = gql`
  mutation createTag(
    $tagType: tagTypeAdminPanel
    $mode: tagMode!
    $tagURL: String!
    $title_En: String!
    $title_Te: String!
    $moderatorHandle: String!
    $moderatorID: String!
    $contentType: tagContentTypes!
    $description_En: String
    $description_Te: String
  ) {
    createTag(
      input: {
        tagType: $tagType
        mode: $mode
        tagURL: $tagURL
        title_En: $title_En
        title_Te: $title_Te
        moderatorHandle: $moderatorHandle
        moderatorID: $moderatorID
        contentType: $contentType
        description_En: $description_En
        description_Te: $description_Te
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const deleteTagMutation = gql`
  mutation deleteTag($PK: String!, $SK: String!) {
    deleteTag(PK: $PK, SK: $SK) {
      statusCode
      statusMessage
    }
  }
`
export const updateTagMutation = gql`
  mutation updateTag(
    $PK: String!
    $SK: String!
    $tagType: tagTypeAdminPanel
    $title_En: String
    $title_Te: String
    $moderatorHandle: String!
    $moderatorID: String!
    $description_En: String
    $description_Te: String
  ) {
    updateTag(
      input: {
        PK: $PK
        SK: $SK
        tagType: $tagType
        title_En: $title_En
        title_Te: $title_Te
        moderatorHandle: $moderatorHandle
        moderatorID: $moderatorID
        description_En: $description_En
        description_Te: $description_Te
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
export const sendPNManually = gql`
  mutation sendPNManually(
    $title_En: String!
    $title_Te: String!
    $description_En: String!
    $description_Te: String!
    $posterURL: String
    $contentType: contentType!
    $personID: String
    $movieID: String
  ) {
    sendPNManually(
      input: {
        title_En: $title_En
        title_Te: $title_Te
        description_En: $description_En
        description_Te: $description_Te
        posterURL: $posterURL
        contentType: $contentType
        personID: $personID
        movieID: $movieID
      }
    ) {
      statusCode
      statusMessage
    }
  }
`
